// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"91f6ee97","5649":"ba3bd4f5","6134":"19147c62","8981":"0fb485e2","9407":"85b472c3"}[chunkId] + ".chunk.css";
};